import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { updateRemitSettings } from '../api/remit-settings.ts';
import { RemitSetting } from '../models/remit-setting.ts';

export default function useUpdateRemitSetting(): UseMutationResult<
  string,
  Error,
  RemitSetting
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: RemitSetting) => updateRemitSettings(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['remitSettings'] });
    },
  });
}
